/**
 * @author vishwadeep.kapoor
 * @Date: 2018-12-03 11:27:21
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-04-16 15:26:42
 */

import React, { PureComponent } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FontAwesomeIcon from 'react-fontawesome';
import styled from 'styled-components';
import { Flex, Box } from 'grid-styled';
import 'react-input-range/lib/css/index.css';
import { Link, Redirect } from 'react-router-dom';

import { AppWrappperHOC } from '../Root/HOC';
import { selectRestaurantsList, selectRestaurantsLocation, selectRestaurantsCuisines, selectRestaurantsCollections, selectRestaurantsDeal, isLoading } from './selectors';
import { DEFAULT_PRE_PAYLOAD, FILTER_CATEGORY, TEXT_NO_RESTAURANT, CONSTRUCT_MOBILE_FILTER_KEYS, SWITCH_PAYLOADS, MAKE_FILTER_TRACKING_LABEL, SORT_DROPDOWN } from './constants';
import { fetchResturantPage, fetchResturantList, successActionList } from './actions';
import { utils, constants, eventTracking } from '../../devUtils';
import Container from '../../components/Container';
import ListFilters from '../../components/ListFilters';
import RestaurantListCard from '../../components/RestaurantListCard';
import Pagination from '../../components/Pagination';
import { selectCity, isMobileScreen } from '../HeaderContainer/selectors';
import { selectSearchRestaurantKey } from '../RestaurantDeals/selectors';
import Modal from '../../components/Modal';
import { changeSearchBox } from '../RestaurantDeals/actions';
import Loader from '../../components/Loader';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';
import GiftImg from '../../assets/images/test.jpg';
import ListFiltersMobile from '../../components/ListFilters/indexMobile';
import { MAKE_FILTER_ACTIVE } from '../GiftCard/constants';
import SelectWrapper from '../../components/SelectWrapper';
// import ShowCart from '../ShowCart';

const PopFilters = styled.div`
  li{
    display:inline-block !important;
    width:30% !important;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width:50% !important;
    };
  }
`;
const PriceDrop = styled.div`
  .select-drop{
    .Select-clear-zone{
      display:none;
    }
  }
`;

export const MobileFiltes = styled.div`
  padding: 10px 0px;
  background: #DFDFDF;
  margin-bottom:0px;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[4]}) {
    background: ${(props) => props.theme.whiteColor};
  };
  
.mobile-filters{
  ul{
    margin:0px;
    padding:0px;
    background:#DFDFDF;
    display: inline-block;
    width: 100%;
    li{
      display:inline-block;
      width:100%;
      text-align:center;
      color:${(props) => props.theme.secondaryColor};
      font-weight:600;
      font-size:18px;
      line-height: 35px;
      .fa{
        margin-right:10px;
      }
      .Select{
        .Select-control{
          background:none;
          font-size:18px;
          .Select-placeholder{
            color:${(props) => props.theme.secondaryColor};
          }
        }
      }
    }
  }
}
  .show{
    display:block !important;
    position: fixed;
    z-index: 9;
    top: 0;
    overflow-y: scroll;
    height: 100%;
    padding-bottom: 50px;
    background:${(props) => props.theme.whiteColor};
    width:100%;
    right: 0px;
    ${Button}{
      width:100%;
      position:fixed;
      bottom:0;
    }
  }
  .none{
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[4]}) {
      display:block !important;
    };
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      display:none !important;
    };
  }
`;
class RestaurantsList extends PureComponent { // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    this.filterPayload = { locations: [], cuisines: [], category: [], Checkbox: [], tag_types: [] }; // this.stateLessKeys
    const { match: { params: { filterKey } = {} } = {} } = this.props;
    const _filterKey = utils.decodeURL(filterKey);
    this.state = {
      isShowModal: false,
      isShowFilter: false,
      selectedCity: props.getSelectedCity,
      restaurantsListData: {},
      locationFilter: [],
      cuisinesFilter: [],
      dealFilter: [],
      collectionFilter: [],
      isLoadingStatus: true,
      filterCategory: this.isKeyMarkedChecked(JSON.parse(JSON.stringify(FILTER_CATEGORY)), _filterKey), /** @desc making the FILTER_CATEGORY unique everytime */
      mobileFilterData: CONSTRUCT_MOBILE_FILTER_KEYS,
    };
    this.stateLessKeys = { filterKey: _filterKey, data: [], payloadKey: 'cuisines', filterTrackingList: [] };
    this.onBookDealClicked = this.onBookDealClicked.bind(this);
    this.onCheckBoxClicked = this.onCheckBoxClicked.bind(this);
    this.mobileFilterClick = this.mobileFilterClick.bind(this);
    this.showMoreClicked = this.showMoreClicked.bind(this);
    this.handleApply = this.handleApply.bind(this);
    this.handleChangeFilters = this.handleChangeFilters.bind(this);
    this.applyCheckedFilters = this.applyCheckedFilters.bind(this);
    this.handleUpdateFilter = this.handleUpdateFilter.bind(this);
  }

  /**
   * @func React lifecycle
   */
  componentWillMount() {
    this.fetchAgain(this.props);
  }

  /**
   * @func React lifeCycle
   * @desc two conditions written 1)as with one updated city will mounted;
   *                              2) the updated resturant and location data will be fetched
   *                              3) if search key is been changed then fetching all records as filter is not required to reset by that time
   *                                 ignoring with the case of key=false
   * @param {object} nextProps
   */
  componentWillReceiveProps(nextProps) {
    const { getSelectedCity, getSelectedCity: { city, location }, getRestaurantsList: restaurantsListData,
      getRestaurantsLocation: locationFilter, getRestaurantsCuisines: cuisinesFilter, dealFilters, collectionFilters, isLoadingStatus } = nextProps;
    if (!utils.isEqual(this.props.getSelectedCity, getSelectedCity)) {
      this.filterPayload = { locations: [], cuisines: [], category: [], tag_types: [] };
      const payload = { city, ...DEFAULT_PRE_PAYLOAD, ...location };
      this.fetchData(payload);
    } else if (!utils.isEqual(this.props.getResturantSearchKey, nextProps.getResturantSearchKey) && nextProps.getResturantSearchKey !== 'false') {
      // this.filterPayload = { locations: [], cuisines: [], category: [], tag_types: [] };
      this.fetchAgain(nextProps, true);
    } else if (!utils.isEqual(this.props.getRestaurantsList, restaurantsListData)) {
      this.setUpdatedObject(getSelectedCity, restaurantsListData, locationFilter, cuisinesFilter, dealFilters, collectionFilters, isLoadingStatus);
    } else {
      this.setState({ isLoadingStatus });
    }
  }

  /**
   * @func React lifecycle
   * @description resetting the GDD_search/merchant_data
   */
  componentWillUnmount() {
    const { location: { pathname } = {} } = utils.getWindowInstance();
    if (pathname !== constants.LINK_SEARCH_RESULT) {
      this.props.onClearSearchChangeGdd();
    }
    this.props.onSuccessActionList({ merchant_data: {} });
  }

  /**
   * @desc getting called from the child component
   * @param {string} restaurantId
   * @see history @argument can be used as it is directly connected with the router else need to use <Link>
   */
  onBookDealClicked(restaurantId, restaurantName) {
    const { history } = this.props;
    this.triggerEventTracker('Restaurant Deals', 'List - Book', restaurantName); // for google analytics event tracking (book a deal click event)
    utils.forceRedirect(history, { pathname: `${constants.LINK_RESTAURANTS_DETAILS}/${restaurantId}` });
  }

  /**
   * @param {string} value
   * @param {*string} type
   * @desc handling all checkbox filtering index
   */
  onCheckBoxClicked(type, value) {
    const _filterPayload = { ...this.filterPayload };
    const index = _filterPayload[type].indexOf(value);
    if (index > -1) {
      _filterPayload[type].splice(index, 1);
    } else {
      _filterPayload[type].push(value);
    }
    this.filterPayload = _filterPayload;
    const { locations: locationsValue, cuisines: cuisinesValue, category: categoryValue, tag_types: tagTypeValue } = this.filterPayload;
    this.triggerEventTracker('Restaurant Deals', 'List - Filters', MAKE_FILTER_TRACKING_LABEL([locationsValue, cuisinesValue, categoryValue, tagTypeValue]));
    const locations = JSON.stringify(locationsValue);
    const cuisines = JSON.stringify(cuisinesValue);
    const category = JSON.stringify(categoryValue);
    const tag_types = JSON.stringify(tagTypeValue);
    const payload = {
      ...this._payload,
      locations,
      cuisines,
      category,
      tag_types,
    };
    utils.checkObjectValues(payload);
    this.fetchData(payload, true);
  }

  /**
   * @desc getting first data and attaching required keys
   * @prop <filternames> <filtername> difference between s
   * @param {filterKey} key in the URL
   * @argument {* true} in isMobileWindow only
   * @returns setState
   */
  setUpdatedObject(selectedCity, restaurantsListData, locationFilters, cuisinesFilters, dealFilters, collectionFilters, isLoadingStatus) {
    const { filterKey, payloadKey, filterTitle } = this.stateLessKeys;
    const { isMobileWindow } = this.props;
    const locationFilter = utils.updateObjectKeys(utils.arraySplice(locationFilters, 0, 5), 'filterName', 'location');
    const cuisinesFilter = this.isKeyMarkedChecked(utils.createArrayToObject(utils.arraySplice(cuisinesFilters, 0, 8), 'filterName'), filterKey);
    const dealFilter = this.isKeyMarkedChecked(utils.updateObjectKeys(dealFilters, 'filterName', 'name'), filterKey, 'Deal Type');
    const collectionFilter = this.isKeyMarkedChecked(utils.updateObjectKeys(collectionFilters, 'filterName', 'name'), filterKey, 'Collections');
    if (isMobileWindow) {
      const { filterCategory } = this.state;
      SWITCH_PAYLOADS({ filterCategory, locationFilters, cuisinesFilters, dealFilter, collectionFilter }, payloadKey, filterTitle, this.applyCheckedFilters);
    }
    this.setState({
      selectedCity,
      restaurantsListData,
      locationFilter,
      cuisinesFilter,
      dealFilter,
      collectionFilter,
      isLoadingStatus,
      locationFilters,
      cuisinesFilters,
    });
  }

  triggerEventTracker(Category, ActionType, Label = null) {
    eventTracking.triggerEvent(Category, ActionType, Label);
  }

  handleApply() {
    const { isShowFilter } = this.state;
    this.setState({ isShowFilter: !isShowFilter });
  }

  /**
 * @param {array}
 * @param {*filterKey}
 * @return {array} @arg {isChecked = true}
 * @todo move to constants
 */
  isKeyMarkedChecked(array, filterKey) {
    const _filterKey = utils.decodeURL(filterKey);
    const reqIndex = utils.lodashFindIndex(array, { filterName: _filterKey });
    if (reqIndex !== -1) {
      const _array = array;
      _array[reqIndex].isChecked = true;
    }
    return array;
  }

  handleChangeFilters(key, filterTitle) {
    const { mobileFilterData } = this.state;
    let _mobileFilterData = [...mobileFilterData];
    _mobileFilterData = MAKE_FILTER_ACTIVE(_mobileFilterData, key, filterTitle);
    SWITCH_PAYLOADS(this.state, key, filterTitle, this.applyCheckedFilters);
    this.setState({ mobileFilterData: _mobileFilterData });
  }

  applyPreFilter(payload) {
    const { match: { params: { filterKey } = {} } = {}, history: { location: { state: { filterType } = {} } } } = this.props;
    if (filterKey && filterType) {
      const _filterKey = utils.decodeURL(filterKey);
      this.filterPayload[filterType] = [_filterKey];
      const obj = { [filterType]: JSON.stringify([_filterKey]) };
      return { ...payload, ...obj };
    }
    return payload;
  }

  handleUpdateFilter(value, { data }) {
    const _payloadCopy = this._payload;
    const payload = { ..._payloadCopy, ...data };
    this.stateLessKeys.filterDropdown = value;
    this.fetchData(payload, true);
  }

  fetchAgain({ getSelectedCity: { city, location }, getResturantSearchKey: keyword }, isListFetch = false) {
    let payload = {
      city,
      ...DEFAULT_PRE_PAYLOAD,
      ...location,
      keyword,
    };
    payload = this.applyPreFilter(payload);
    this.fetchData(payload, isListFetch);
  }

  fetchData(payload, isListFetch) {
    this._payload = payload;
    if (isListFetch) {
      this.props.onFetchRestaurantsList(payload);
    } else {
      this.props.onFetchRestaurantsPage(payload);
    }
  }

  mobileFilterClick() {
    const { isShowFilter } = this.state;
    this.setState({ isShowFilter: !isShowFilter });
  }

  /**
   * @callback typeof(type)==='string'
   * @param {*location/cuisines} type
   * @param {*allArray} data
   */
  showMoreClicked(type, data, otherParams) {
    if (typeof (type) === 'string') {
      this.applyCheckedFilters(type, data, otherParams);
    }
    const { isShowModal } = this.state;
    this.setState({ isShowModal: !isShowModal });
  }

  applyCheckedFilters(type, data, otherParams) {
    let _data = data;
    if (typeof (type) === 'string' && type === 'category') { // !showMore
      this.filterPayload.category.map((item) => this.isKeyMarkedChecked(_data, item));
    } else if (typeof (type) === 'string' && type === 'locations') {
      _data = utils.updateObjectKeys(data, 'filterName', 'location');
      this.filterPayload.locations.map((item) => this.isKeyMarkedChecked(_data, item));
    } else if (typeof (type) === 'string' && type === 'tag_types' && otherParams === 'Deal Type') {
      this.filterPayload.tag_types.map((item) => this.isKeyMarkedChecked(_data, item));
    } else if (typeof (type) === 'string' && type === 'tag_types' && otherParams === 'Collections') {
      this.filterPayload.tag_types.map((item) => this.isKeyMarkedChecked(_data, item));
    } else if (typeof (type) === 'string' && type === 'cuisines') {
      _data = utils.createArrayToObject(data, 'filterName');
      this.filterPayload.cuisines.map((item) => this.isKeyMarkedChecked(_data, item));
    }
    this.stateLessKeys.payloadKey = type;
    this.stateLessKeys.data = _data;
  }

  /**
   * @param {*payloadKey and data} from this.stateLessKeys
   * @return {component} ListFilters
   */
  renderModalData() {
    const { payloadKey, data } = this.stateLessKeys;
    return (<ListFilters
      seeMore={false}
      seeMoreHandle={this.showMoreClicked}
      payloadKey={payloadKey}
      filters={data}
      onChange={this.onCheckBoxClicked}
    />);
  }

  render() {
    const { selectedCity: { city },
      restaurantsListData, locationFilter, cuisinesFilter, dealFilter, collectionFilter, filterCategory,
      isShowFilter, isShowModal, isLoadingStatus, locationFilters, cuisinesFilters, mobileFilterData,
    } = this.state;
    const { category } = this.filterPayload;
    const { isMobileWindow } = this.props;
    const { payloadKey, data, filterDropdown } = this.stateLessKeys;
    const Categories = category.join(', ');
    if (isLoadingStatus) {
      return <Loader />;
    } else if (true) {
      return (<Redirect to={constants.LINK_HOME} />);
    }
    return (
      <div>
        <Breadcrumb />
        {/* <ShowCart /> */}
        <Container>
          <Modal
            header={payloadKey}
            show={isShowModal}
            onClose={this.showMoreClicked}
          >
            <PopFilters>
              {isShowModal && this.renderModalData()}
            </PopFilters>
          </Modal>
          <Flex flexWrap="wrap" className="sm-none">
            <Box w={[10 / 12]}>
              <Flex flexWrap="wrap">
                <Box w={[9 / 12]}>
                  <h2 style={{ margin: '0', padding: '10px 0px' }}>
                    Best {Categories || 'Restaurants'}  in {city}
                  </h2>
                </Box>
                <Box w={[3 / 12]} pr="20px">
                  <PriceDrop>
                    <SelectWrapper
                      placeholder="Rating"
                      className="select-drop"
                      name="form-field-name"
                      onChange={this.handleUpdateFilter}
                      options={SORT_DROPDOWN}
                      value={filterDropdown}
                    />
                  </PriceDrop>
                </Box>
              </Flex>
            </Box>
            <Box w={[2 / 12]} style={{ position: 'relative' }}>
              {/* <div style={{ position: 'absolute', bottom: '10px' }}><strong>Featured Deals</strong></div> */}
            </Box>
          </Flex>
          <Flex flexWrap="wrap">
            <Box w={[1, 2 / 12, 2 / 12]} >
              <MobileFiltes>
                <div className="mobile-filters lg-none">
                  <ul>
                    <li onClick={this.mobileFilterClick} role="presentation"><FontAwesomeIcon name="filter" />Filters</li>
                  </ul>
                </div>
                <div className={isShowFilter ? 'show' : 'none'}>
                  {isMobileWindow ?
                    <React.Fragment>
                      <ListFiltersMobile
                        mainTitle="Filters"
                        showFilter={this.handleChangeFilters}
                        filterResults={data}
                        filters={mobileFilterData}
                        onChange={this.onCheckBoxClicked}
                        payloadKey={payloadKey}
                        handleApply={this.handleApply}
                      />
                      {/* <Button type="primary" onClick={this.handleApply}>Apply</Button> */}
                    </React.Fragment> :
                    <React.Fragment>
                      <ListFilters
                        mainTitle="Filters"
                        filterTitle="Categories"
                        payloadKey="category"
                        filters={filterCategory}
                        onChange={this.onCheckBoxClicked}
                      />
                      <ListFilters
                        filterTitle="Locations"
                        payloadKey="locations"
                        search={false}
                        seeMore
                        seeMoreHandle={this.showMoreClicked}
                        filters={locationFilter}
                        allFilters={locationFilters}
                        onChange={this.onCheckBoxClicked}
                      />
                      <ListFilters
                        filterTitle="Deal Type"
                        payloadKey="tag_types"
                        filters={dealFilter}
                        onChange={this.onCheckBoxClicked}
                      />
                      <ListFilters
                        filterTitle="Collections"
                        filters={collectionFilter}
                        payloadKey="tag_types"
                        onChange={this.onCheckBoxClicked}
                      />
                      <ListFilters
                        filterTitle="Cuisines"
                        payloadKey="cuisines"
                        seeMore
                        seeMoreHandle={this.showMoreClicked}
                        filters={cuisinesFilter}
                        allFilters={cuisinesFilters}
                        onChange={this.onCheckBoxClicked}
                      />
                    </React.Fragment>}
                </div>
              </MobileFiltes>
            </Box>
            <Box w={[1, 8 / 12]} pr="20px" pl="20px" className="nopadding">
              {
                restaurantsListData && restaurantsListData.data && restaurantsListData.data.length ?
                  restaurantsListData.data.map((card) =>
                    <RestaurantListCard key={card.merchant_id} {...card} onBookDealClick={this.onBookDealClicked} />) :
                  <div className="noresult">{TEXT_NO_RESTAURANT}</div>
              }
              <Pagination
                totalRecords={restaurantsListData.totalRecords}
                onChange={this.props.onFetchRestaurantsList}
                defaultPayload={this._payload}
                module="restaurant"
              />
            </Box>
            <Box w={[1, 2 / 12]} className="padding20 sm-none">
              <Link to={constants.LINK_PLAN_PARTY} onClick={() => this.triggerEventTracker('Restaurant Deals', 'Plan a Party banner', constants.LINK_RESTAURANTS_DEALS)}>
                <img src={GiftImg} className="sm-none" alt="" />
              </Link>
              {/* {
                featureDeals.map((deal) => <FeaturedDeals key={deal.cost} {...deal} />)
              } */}

            </Box>
          </Flex>
        </Container>
      </div>
    );
  }
}

RestaurantsList.propTypes = {
  onFetchRestaurantsPage: PropTypes.func,
  onFetchRestaurantsList: PropTypes.func,
  history: PropTypes.object,
  match: PropTypes.object,
  getRestaurantsList: PropTypes.shape({
    totalRecords: PropTypes.number,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        merchant_name: PropTypes.string,
        location: PropTypes.string,
        cuisines: PropTypes.arrayOf(PropTypes.string),
        cost_for_two: PropTypes.number,
        group_deals_data: PropTypes.arrayOf(
          PropTypes.shape({
            deal_title: PropTypes.string,
          })
        ),
      })
    ),
  }),
  getSelectedCity: PropTypes.shape({
    city: PropTypes.string,
    location: PropTypes.shape({
      latitude: PropTypes.number,
      longitude: PropTypes.number,
    }),
  }),
  getRestaurantsLocation: PropTypes.arrayOf(
    PropTypes.shape({
      distance: PropTypes.number,
      location: PropTypes.string,
    })
  ),
  getRestaurantsCuisines: PropTypes.arrayOf(
    PropTypes.string
  ),
  getResturantSearchKey: PropTypes.string,
  collectionFilters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  dealFilters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  onClearSearchChangeGdd: PropTypes.func,
  onSuccessActionList: PropTypes.func,
  isLoadingStatus: PropTypes.bool,
  isMobileWindow: PropTypes.bool,
};


const mapDispatchToProps = (dispatch) => ({
  onFetchRestaurantsPage: (payload) => dispatch(fetchResturantPage(payload)),
  onFetchRestaurantsList: (payload) => dispatch(fetchResturantList(payload)),
  onClearSearchChangeGdd: (value) => dispatch(changeSearchBox(value)),
  onSuccessActionList: (payload) => dispatch(successActionList(payload)),
});

const mapStateToProps = createStructuredSelector({
  getRestaurantsList: selectRestaurantsList(),
  getRestaurantsLocation: selectRestaurantsLocation(),
  getRestaurantsCuisines: selectRestaurantsCuisines(),
  collectionFilters: selectRestaurantsCollections(),
  dealFilters: selectRestaurantsDeal(),
  getSelectedCity: selectCity(),
  getResturantSearchKey: selectSearchRestaurantKey(),
  isLoadingStatus: isLoading(),
  isMobileWindow: isMobileScreen(),
});

const component = connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(RestaurantsList));
export default component;



// WEBPACK FOOTER //
// client/containers/RestaurantsList/index.js